<div class="af-language">
  <kendo-dropdownlist
    [data]="languages"
    textField="{{'text' | translate}}"
    valueField="value"
    [(ngModel)]="language"
    (valueChange)="switchLanguage($event)"
  >
  </kendo-dropdownlist>
</div>
